export const API_BASE = 'https://api.derskaynagi.com/api/v2512'
export const API_IM = 'https://api.derskaynagi.com/api/v2512'
export const API_BASE_Q= 'https://api.derskaynagi.com/api/v2512/query'
export const IMG_BASE = 'https://api.derskaynagi.com'
export const IMG_BASE_NO = 'https://sci2512r2.siparisci.com'